// filepath: /Users/josephlynn/workspaces/MyNJAppeal/src/pages/DefaultPages/common/UserUtils.ts
import { fetchAuthSession, getCurrentUser } from "aws-amplify/auth";
import { CognitoUser } from "../../../commontypes/types";

interface AuthSession {
  tokens?: {
    idToken?: {
      payload: {
        email: string;
        phone_number?: string;
        "cognito:groups"?: string[];
      };
    };
  };
}

export const getCurrentUserAndGroups = async (): Promise<{ cognitoUser: CognitoUser | undefined; userGroups: string[] } | null> => {
  try {
    const authUser = await getCurrentUser();
    if (!authUser) {
      return null;
    }
    let userGroups: string[] = [];
    let user: CognitoUser | undefined = undefined;
    try {
      const session = await fetchAuthSession() as AuthSession;
      const { idToken } = session.tokens ?? {};
      if (idToken && idToken.payload["cognito:groups"]) {
        userGroups = idToken.payload["cognito:groups"];
      }
      user = {
        username: authUser.username,
        email: idToken?.payload.email || "",
        phoneNumber: idToken?.payload.phone_number?.substring(2)
      };
    } catch (err) {
      console.log("fetchAuthSession error:", err);
    }
    return { cognitoUser: user, userGroups };
  } catch (err) {
    //console.log("getCurrentUser error:", err);
    return null;
  }
};

export const getJWTToken = async (): Promise<string | null> => {
  const session: AuthSession = await fetchAuthSession() as AuthSession;
  if (session) {
    return session.tokens?.idToken?.toString() ?? null;
  }
  return null;
};